import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=bfa136c6&scoped=true&"
import script from "./Master.vue?vue&type=script&lang=js&"
export * from "./Master.vue?vue&type=script&lang=js&"
import style0 from "./Master.vue?vue&type=style&index=0&id=bfa136c6&prod&lang=css&"
import style1 from "./Master.vue?vue&type=style&index=1&id=bfa136c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa136c6",
  null
  
)

export default component.exports